import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { CardPackCategory } from '@sorare/core/src/__generated__/globalTypes.ts';
import { BrandXXS } from '@sorare/core/src/atoms/typography/index.tsx';
import { TimeLeft } from '@sorare/core/src/contexts/ticker/TimeLeft/index.tsx';

import type { PackBadge_cardPack } from './__generated__/index.graphql.ts';

const Badge = styled(BrandXXS)`
  background: var(--c-nd-100);
  color: var(--c-white);
  padding: 2px var(--half-unit);
  border-radius: var(--half-unit);
`;

const EndDateBadge = styled(Badge)`
  background: var(--c-gradient-gold);
  color: var(--c-black);
`;
type Props = {
  cardPack: PackBadge_cardPack;
};

export const PackBadge = ({ cardPack }: Props) => {
  const { endDate, canPurchase, category } = cardPack;

  if (
    !canPurchase &&
    category === CardPackCategory.ONLY_STARTING_PLAYERS_TEMPLATE
  ) {
    return (
      <Badge>
        <FormattedMessage defaultMessage="Live when lineups are out" />
      </Badge>
    );
  }

  if (endDate) {
    return (
      <EndDateBadge>
        <FormattedMessage
          defaultMessage="Ends in {time}"
          values={{ time: <TimeLeft time={endDate} /> }}
        />
      </EndDateBadge>
    );
  }
  return null;
};

PackBadge.fragments = {
  cardPack: gql`
    fragment PackBadge_cardPack on CardPack {
      slug
      endDate
      canPurchase
      category
    }
  ` as TypedDocumentNode<PackBadge_cardPack>,
};
